import Typography from "@vapor/react-extended/ExtendedTypography";
import { Checkbox, FormControlLabel, Stack } from "@vapor/react-material";
import Divider from "@vapor/react-material/Divider";
import { faFileInvoiceDollar } from "@fortawesome/pro-regular-svg-icons";
import VaporIconBase from "@vapor/react-icons/VaporIconBase";
import { useTranslation } from "@onefront/react-sdk";

const FileInfoCell = ({
  fileName,
  handleBoxChange,
  isDocumentSelected,
  title,
}) => {
  const { t } = useTranslation("DOCS");
  return (
    <Stack
      direction="row"
      gap="5px"
      sx={{
        display: "flex",
        padding: "6px 2px",
        alignItems: "center",
        width: "55%",
      }}
    >
      <FormControlLabel
        sx={{
          margin: "0px",
        }}
        control={
          <Checkbox
            checked={isDocumentSelected}
            onChange={handleBoxChange}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        }
        label={""}
      />
      <VaporIconBase color="interactive" icon={faFileInvoiceDollar} />
      <Stack paddingLeft="8px">
        <Typography
          color="primary.textTitleColor"
          noWrap
          sx={{
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          variant="bodyLarge"
        >
          {title}
        </Typography>
        <Stack alignItems="center" direction="row" spacing={2}>
          <Typography variant="body" color="primary.textSubduedColor" noWrap>
            50 KB
          </Typography>
          <Divider flexItem orientation="vertical" />
          <Typography color="primary.textSubduedColor" noWrap variant="body">
            {t("classification.fileName")}:
          </Typography>
          <Typography
            noWrap
            sx={{
              marginLeft: "4px !important",
              maxWidth: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            variant="body500"
          >
            {fileName}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default FileInfoCell;
